<template>
  <div class="vipTab">
    <div class="handle-box">
      <el-input
        v-model="keyword"
        placeholder="请输入手机号"
        class="handle-input mr10"
      ></el-input>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch"
        >搜索</el-button
      >
    </div>
    <div v-if="JSON.stringify(user) != '{}'" class="userInfo">
      <dl class="dls">
        <dt><img :src="user.avatar" alt="" /></dt>
        <dd>
          <p>昵称：{{ user.nickname }}</p>
          <p>手机号：{{ user.phone }}</p>
        </dd>
      </dl>
      <div class="chongzhi">
        <el-button type="primary" @click="chongzhi">充值</el-button>
      </div>
    </div>
    <div v-if="vip.length > 0" class="vipList">
      <p class="pp">VIP列表</p>
      <el-table
        :data="vip"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="user_id"
          label="user_id"
          align="center"
        ></el-table-column>
        <el-table-column prop="vip_id" label="vip类型" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row
                ? scope.row.vip_id == 1
                  ? "基础会员"
                  : "学霸会员"
                : "基础会员"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deadline_time"
          label="到期时间"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <div v-if="log.length > 0" class="vipList">
      <p class="pp">充值记录列表</p>
      <el-table
        :data="log"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="admin_name" label="管理员名字" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row
                ? scope.row.admin_name
                  ? scope.row.admin_name
                  : "/"
                : "/"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="card_name" label="会员卡名称" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row
                ? scope.row.card_name
                  ? scope.row.card_name
                  : "/"
                : "/"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vip_id" label="vip类型" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row
                ? scope.row.vip_id == 1
                  ? "基础会员"
                  : "学霸会员"
                : "基础会员"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="add_type" label="购买类型" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row
                ? scope.row.add_type == 1
                  ? "购买会员"
                  : "管理员添加"
                : "/"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="days"
          label="开通天数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="before_deadline_time"
          label="开通前截止时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="after_deadline_time"
          label="开通后截止时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row ? (scope.row.remark ? scope.row.remark : "/") : "/"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="czVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        :label-position="labelPosition"
        label-width="100px"
        :model="formLabelAlign"
      >
        <el-form-item label="VIP类型">
          <el-select
            v-model="formLabelAlign.vip_id"
            placeholder="活动区域"
            style="width: 250px"
          >
            <el-option label="基础会员" value="1"></el-option>
            <el-option label="学霸会员" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否发送短信">
          <el-select v-model="formLabelAlign.is_send" style="width: 250px">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="天数">
          <el-input
            v-model="formLabelAlign.days"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="formLabelAlign.remark"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="czVisible = false">取消</el-button>
          <el-button type="primary" @click="onSubmit">充值</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/gaeaApiConfig";

export default {
  name: "Userslist",
  data() {
    return {
      labelPosition: "center",
      keyword: "",
      user: {},
      vip: [],
      log: [],
      czVisible: false,
      formLabelAlign: {
        vip_id: "1",
        days: "",
        remark: "",
        is_send: "1",
      },
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["phone"] = that.keyword;
      http.get("/admin/user/vip", { params: params }).then(function(res) {
        if (res.data.status_code == 200) {
          that.user = res.data.data.user;
          that.vip = res.data.data.vip;
          that.log = res.data.data.log;
        }
      });
    },
    chongzhi() {
      console.log("123");
      this.czVisible = true;
    },
    onSubmit() {
      http
        .post("/admin/create_vip/" + this.user.id, this.formLabelAlign)
        .then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("充值成功");
            this.czVisible = false;
            this.handleSearch();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style scoped>
.vipTab {
  width: 100%;
  height: 100%;
}

.handle-box {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px 30px 20px 30px;
  box-sizing: border-box;
}

.userInfo {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px 30px 20px 30px;
  box-sizing: border-box;
  display: flex;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.dls {
  width: 80%;
  height: 70px;
  display: flex;
  align-items: center;
}

.dls dt {
  width: 100px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: left;
}

.dls dt img {
  width: 70px;
  height: 70px;
}

.dls dd {
  margin-left: 20px;
  line-height: 30px;
}
.dls dd p {
  font-size: 16px;
}
.chongzhi {
  flex: 1;
  display: flex;
  justify-content: right;
  align-items: center;
}
.vipList {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px 30px 20px 30px;
  box-sizing: border-box;
  margin-top: 20px;
}
.vipList .pp {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}
</style>
